export default __webpack_public_path__ + "static/media/bluelace-tracer.64df534e.jpg";